var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('v-progress-circular',{attrs:{"size":126,"width":2,"color":"primary","indeterminate":""}},[_c('h4',{staticClass:"subtitle-1 white--text"},[_vm._v("\n      "+_vm._s(_vm.loading.msg)+"\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }